export default __webpack_public_path__ + "static/media/DS-DIGIT.063ff1f7.TTF";